import React, { FC } from 'react'
import styled from 'styled-components'

import { useTheme } from '@/contexts'
import { ThemeType } from '@/styles/theme'

export type NotificationType = 'success' | 'error' | 'warning' | 'default'

const notificationColors = (theme: ThemeType): Record<NotificationType, string> => ({
  success: theme.color.accentBlue,
  error: theme.color.red,
  warning: theme.color.yellow,
  default: theme.color.textBlack
})

type Notify = {
  message: string
  type: NotificationType
}

type Props = {
  notifies: Array<Notify>
}

const Container = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 30px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 100;
`

const MessageItem = styled.div<{ type: NotificationType }>`
  padding: 10px 15px;
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme, type }) => notificationColors(theme)[type]};
  border-radius: 4px;
  font-weight: bold;
  box-shadow: 0 0 6px 1px ${({ theme }) => theme.color.borderGray};
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const UiNotificationBox: FC<Props> = ({ notifies = [] }) => {
  const { theme } = useTheme()

  return (
    <Container>
      {notifies.map((notify, idx) => (
        <MessageItem key={idx} type={notify.type} theme={theme}>
          {notify.message}
        </MessageItem>
      ))}
    </Container>
  )
}
